module.exports = __webpack_public_path__ + "static/Montserrat-Regular-3fe868a1a9930b59d94d2c1d79461e3c.ttf";